var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"betslip__system-box",attrs:{"tag":"div","name":"animation-list__drop-in-"}},_vm._l((_vm.systems),function(system){return _c('SystemCheckbox',{key:system.toString(),attrs:{"system":system,"label":_vm.getLabel(system),"disabled":_vm.isDisabled},on:{"systemClick":_vm.onSystemClick}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28680142","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/betSlip/Systems.vue
// module id = 2111
// module chunks = 0